import { useEffect, useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import UserPanelSidebar from '../../Components/UserPanelSidebar/UserPanelSidebar'
import { Route, Routes, useNavigate } from 'react-router-dom';
import './UserPanel.css'
import UserOrder from '../../Components/UserOrder/UserOrder';
import UserHome from '../../Components/UserHome/UserHome';
import UserCourses from '../../Components/UserCourses/UserCourses';
import UserFavorite from '../../Components/UserFavorite/UserFavorite';
import { isLoggedIn } from '../../Hooks/isLoggedIn';
import UserPanelSavedCourses from '../../Components/UserPanelSaveItem/UserPanelSaveItem';
import UserPanelSaveItem from '../../Components/UserPanelSaveItem/UserPanelSaveItem';
import UserPanelEditInfo from '../../Components/UserPanelEditInfo/UserPanelEditInfo';
import TitleSectionComponent from '../../Components/TitleSectionComponent/TitleSectionComponent';
import { FaUserCog } from 'react-icons/fa'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration';

export default function UserPanel() {
    const nav = useNavigate();
    if (!isLoggedIn()) nav("/Login");

    const [user, setUser] = useState({
        id: '',
        username: '',
        profileImage: '',
        registeredCourseSave:[],
        factorItems:[]
    })
    const navigate = useNavigate();
    useEffect(() => {
        axiosConfig.get("api/user").then((res) => {
            setUser(res.data)
        }).catch((res) => {
            navigate("/")
        })
    }, [])

    return (
        <>
            <div className='user-panel'>
                <div className='user-panel-title-res'>
                    <TitleSectionComponent title='پنل کاربری' icon={<FaUserCog />} />
                </div>
                <Container className='user-panel-container'>
                    <Row className='user-panel-row'>
                        <Col lg={3}>
                            <UserPanelSidebar user={user}/>
                        </Col>
                        <Col lg={9}>
                            <div className='user-panel-page'>
                                <Routes>
                                    <Route path="" element={<UserHome user={user}/>} />
                                    <Route path="mycourses" element={<UserCourses />} />
                                    <Route path="order" element={<UserOrder />} />
                                    <Route path="saveItems" element={<UserPanelSaveItem />} />
                                    <Route path="editInfo" element={<UserPanelEditInfo />} />
                                </Routes>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}
